module.exports = __webpack_public_path__ + "media/images/twitter-ca0054519f62a7d3c46a72a1e8a1b5db.svg";